module.exports = __webpack_public_path__ + "static/img/American-Credit-Equipment-Financing-Customer-Vioce-960w.3b6680e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American-Credit-Equipment-Financing-Customer-Vioce-960w.png
// module id = 801
// module chunks = 5